import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Faq from '../../../../components/Faq/faq';
import Banner from '../../../../components/Bannersection/banner';
import { Helmet } from "react-helmet";

function Crm() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          const headerOffset = 250;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }, 300);
      }
    }
  }, [location, location.hash]);

  const pagename = [{ pagetitle: "CRM Solutions", subtitle: "CRM" }];

  const faqitem = [
    { Faq_id: "collapseone", data_bs_target: "#collapseone", question: "Why does my business need a CRM system?", answer: "A CRM system centralises your customer data, streamlines sales processes, and enhances customer service. It allows your team to build stronger relationships with clients, leading to increased loyalty and higher sales conversions." },
    { Faq_id: "collapsetwo", data_bs_target: "#collapsetwo", question: "What types of CRM services do you offer?", answer: "We offer end-to-end CRM services including Custom CRM Development, Cloud-based CRM Setup, Third-party Integration (like HubSpot, Salesforce), Data Migration, and ongoing CRM Support & Maintenance." },
    { Faq_id: "collapseThree", data_bs_target: "#collapseThree", question: "Can CRM help with marketing automation?", answer: "Yes, advanced CRM solutions include marketing automation capabilities. You can track customer interactions, set up automated email campaigns, target specific audience segments, and analyse marketing performance all within the CRM." },
    { Faq_id: "collapseFour", data_bs_target: "#collapseFour", question: "Will the new CRM integrate with our emails and existing software?", answer: "Absolutely. We ensure your CRM is fully integrated with your existing communication tools, email platforms, ERP systems, and internal software to ensure data flows seamlessly across your organisation." },
    { Faq_id: "collapseFive", data_bs_target: "#collapseFive", question: "Is custom CRM development better than off-the-shelf software?", answer: "Custom CRM offers the flexibility to perfectly match your unique business workflows without forcing your team to adapt to generic software limitations. While off-the-shelf CRM is faster to deploy, a custom CRM provides long-term value, unparalleled scalability, and tailored features." },
  ];

  return (
    <div>
      <Helmet>
        <title>Customer Relationship Management (CRM) | DGI Worx Australia</title>
        <meta name="description" content="Enhance customer relationships and drive sales growth with DGI Worx's comprehensive CRM solutions and seamless integrations." />
        <meta name="keywords" content="crm solutions, customer relationship management, custom crm, cloud crm, crm integration, sales automation, DGi WORX, dgiworx, australia" />
        <meta property="og:title" content="CRM Solutions | Custom & Cloud CRM Services | DGi WORX Australia" />
        <meta property="og:description" content="Explore DGi WORX's advanced CRM solutions covering custom development, cloud deployment, and system integration. Transform your customer experience." />
        <meta property="og:image" content="/assets/img/dgiworx-home-embedded.jpg" />
        <meta property="og:url" content="https://dgiworx.com.au/crm" />
        <link rel="canonical" href="https://dgiworx.com.au/crm" />
        <link rel="alternate" hreflang="en-au" href="https://dgiworx.com.au/" />
      </Helmet>

      <Banner items={pagename} />
      <h1 className='d-none'>Customer Relationship Management Solutions - DGi WORX Australia</h1>

      <section className="about-area tp-about-two py-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="tp-about-two-wrap mt-10 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-about-two-thumb">
                  <div className='tp-about-circle'>
                    <div className='tp-about-circle-two'>
                      <img src="/assets/img/service/crm/01.png" alt="customer relationship management" loading='lazy' />
                    </div>
                  </div>
                </div>
                <div className="tp-about-two-thumb-shape tp-thumb-common fix">
                  <div className="tp-thumb-common-overlay wow"></div>
                  <img src="/assets/img/service/automation/02.jpg" alt="" loading='lazy' />
                </div>
                <div className="tp-about-two-thumb-shape-two d-none d-md-block">
                  <img src="/assets/img/about/two/dote.png" alt="" loading='lazy' />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tp-about-two-wrapper mb-10 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".4s">
                <div className="tp-section mb-40">
                  <span className="tp-section-sub-title">Elevate Customer Experience</span>
                  <h2 className="tp-section-title">CRM SOLUTIONS</h2>
                  <div className="tp-section-title-wrapper">
                    <p>At DGi WORX, we provide smart and scalable Customer Relationship Management (CRM) solutions that help Australian businesses build stronger relationships with their customers. Our CRM system simplifies daily operations, automates repetitive tasks, and gives you valuable insights into customer behaviourâ€”helping you grow faster and make better decisions.<br /><br /></p>
                  </div>
                </div>
                <div className="tp-about-two-list">
                  <ul>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Centralised Customer Data</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Sales Automation</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Marketing Insights</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Improved Customer Support</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Custom Integrations</li>
                    <li><span><img src="/assets/img/icon/check-list.png" alt="" loading='lazy' /></span>Scalable Architecture</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-about-two-shape">
          <div className="tp-about-two-shape-4">
            <img src="/assets/img/about/two/about-2-shape-2.png" alt="" loading='lazy' />
          </div>
        </div>
      </section>

      <section className="feature-area tp-feature-5-wrap py-50">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <div className="tp-section text-center mb-50">
                <span className="tp-section-sub-title">Driving Business Value</span>
                <h2 className="tp-section-title">Our CRM Services</h2>
                <p>Equip your team with the right tools to capture leads, accelerate sales funnels, and retain modern customers effectively.</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="">
              <div className='sub-services mb-50' id="cloud-crm">
                <div className='row align-items-center'>
                  <div className="col-lg-4 col-md-5 col-sm-12">
                    <div className="text-center sub-service-carde mb-20">
                      <div className="sub-service-carde-img tp-thumb-common fix overlay-anim">
                        <div className="corner-border"></div>
                        <img src="/assets/img/service/crm/cloud.png" loading='lazy' style={{ width: '100%', height: '100%', maxHeight: '300px', objectFit: 'cover' }} />
                        <div className="bottom-corner"></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7 col-sm-12">
                    <div className="tp-blog-item-content">
                      <div className="tp-blog-item-title sub-service mb-30">
                        <h4>CLOUD CRM SOLUTIONS</h4>
                        <p>Modern businesses require mobility and real-time data access. Our Cloud CRM solutions empower your remote and on-field sales teams to access critical customer profiles, update interaction logs, and close deals securely from anywhere in Australia or overseas.<br /><br />DGi WORX specialises in deploying robust, cloud-hosted CRM architectures offering high availability and seamless automatic updates. Experience worry-free infrastructure, state-of-the-art security, and a unified platform that aligns your sales and marketing efforts instantaneously.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='sub-services mb-50' id="custom-crm">
                <div className='row align-items-center'>
                  <div className="col-lg-4 col-md-5 col-sm-12 order-md-2">
                    <div className="text-center sub-service-carde mb-20">
                      <div className="sub-service-carde-img tp-thumb-common fix overlay-anim">
                        <div className="corner-border"></div>
                        <img src="/assets/img/service/crm/custom.jpg" loading='lazy' style={{ width: '100%', height: '100%', maxHeight: '300px', objectFit: 'cover' }} />
                        <div className="bottom-corner"></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7 col-sm-12 order-md-1">
                    <div className="tp-blog-item-content">
                      <div className="tp-blog-item-title sub-service mb-30">
                        <h4>CUSTOM CRM DEVELOPMENT</h4>
                        <p>A "one size fits all" application rarely provides the competitive edge your business desires. DGi WORX's Custom CRM Development delivers personalised modules specifically mapped to your unique sales cycle, service workflows, and industry logic.<br /><br />We work closely with your stakeholders throughout the development lifecycle to design highly intuitive user interfaces that promote high employee adoption rates. Gain full ownership over your data logic and construct a system capable of scaling alongside your unique enterprise ambitions.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='sub-services mb-10' id="crm-integration">
                <div className='row align-items-center'>
                  <div className="col-lg-4 col-md-5 col-sm-12">
                    <div className="text-center sub-service-carde mb-20">
                      <div className="sub-service-carde-img tp-thumb-common fix overlay-anim">
                        <div className="corner-border"></div>
                        <img src="/assets/img/service/crm/integration.jpg" loading='lazy' style={{ width: '100%', height: '100%', maxHeight: '300px', objectFit: 'cover' }} />
                        <div className="bottom-corner"></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7 col-sm-12">
                    <div className="tp-blog-item-content">
                      <div className="tp-blog-item-title sub-service mb-30">
                        <h4>SYSTEM INTEGRATION & MIGRATION</h4>
                        <p>Transitioning from spreadsheets, legacy databases, or disjointed tools to a unified platform doesn't have to be disruptive. Our dedicated configuration and seamless data migration workflows ensure your historical customer records are securely transferred without corruption or downtime.<br /><br />DGi WORX offers comprehensive integration services, connecting your new or existing CRM with ERP platforms, Helpdesk software, email marketing services, and VOIP systems. Empower your teams by automating data entry and ensuring that unified, up-to-date customer metrics flow beautifully across your entire technological ecosystem.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Faq items={faqitem} />
    </div>
  );
}

export default Crm;
